import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { modalAnatomy } from '@chakra-ui/anatomy';

const config = createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseStyle = config.definePartsStyle({
  dialog: {
    borderLeftRadius: 16,
  },
  dialogContainer: {
    color: 'white',
    _light: { color: 'texas.bg.900' },
  },
});

export default config.defineMultiStyleConfig({ baseStyle });
